import React, { useRef } from 'react';
var VeltCommentsSidebarV2EmptyPlaceholder = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-empty-placeholder-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2EmptyPlaceholder;
